import { MaxBreakPoints } from "./style/constants";

const mediaQueryMax = (size: string) =>
  `@media only screen and (max-width: ${size})`;

export const mediaQueryMaxMedium = mediaQueryMax(MaxBreakPoints.MEDIUM + "px");
